import { DropdownSelectorType } from '../types/interfaces';

export const statuses: DropdownSelectorType[] = [
  { label: 'Новая', id: 1 },
  { label: 'Назначение исполнителя', id: 1 },
  { label: 'Взята в работу', id: 2 },
  { label: 'Выезд на объект', id: 3 },
  { label: 'Работа на объекте', id: 4 },
  { label: 'Устранение неполадок', id: 5 },
  { label: 'Требуется поддержка', id: 6 },
  { label: 'На согласовании', id: 7 },
  { label: 'Завершена', id: 8 },
  { label: 'Отменена', id: 9 },
  { label: 'Отклононена', id: 10 }
];
